import axios, { type AxiosInstance } from 'axios';
import queryString from 'query-string';

import { clientAuth } from './authService';
import { injectAuthInterceptor } from './interceptor';

export const createAxiosSdkInstance = (
  baseURL: string,
  injectAuth?: boolean,
): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    paramsSerializer: {
      serialize: (params) =>
        queryString.stringify(params, { arrayFormat: 'comma' }),
    },
  });

  if (injectAuth) {
    injectAuthInterceptor(
      instance,
      () => clientAuth.getStoredJwt(),
      async () => clientAuth.refreshToken(),
      () => clientAuth.logoutSync(),
    );
  }

  return instance;
};
